<template>
  <article>
    <header class="view__header">
      <h2 class="view__title">{{ title }}</h2>
    </header>



      <article class="view__content">

      <div class="view__panel">
        <div class="form js-form">
          <submenu></submenu>

           <list class="view__content"
            :data="entries()"
            :fields="headers()"
            :pagination="pagination"
            :hideCreate="false"
            v-on:paginate="paginate"
            v-on:action="action" />
        </div>
      </div>
    </article>
  </article>
</template>

<script>
import L from 'services/Localization'
import List from 'components/layout/list'
import { mapGetters } from 'vuex'
import listHelpers from 'mixins/list-helpers'
import Submenu from 'components/views/account/Submenu'

export default {
  name: 'users',
  components: { List, Submenu },
  mixins: [listHelpers],
  beforeCreate() {
    this.$store.dispatch('getUsers')
  },
  data() {
    return {
      title: L.localize('Users_Breadcrumb_Index')
    }
  },
  computed: {
    ...mapGetters({
      users: 'allUsers',
      pagination: 'allUsersPagination'
    })
  },
  methods: {
    paginate(pageNumber) {
      this.$store.dispatch('getUsers', {
        page: pageNumber
      })
    },
    action(command) {
      switch (command.name) {
        case 'detail':
          this.$router.push({name: 'user', params: { id: command.item.id }})
          break;
        case 'create':
          this.$router.push({name: 'user-create'})
          break;
      }
    },
    entries: function() {
      return this.users
    },
    headers: function() {
      let headers = [
        { prop: 'emailAddress', label: L.localize('Label_EmailAddress') },
        { prop: 'lastLoginTime', label: L.localize('Users_LastLoginTime'), transform: this.showDate },
        { prop: 'isActive', label: L.localize('Label_IsActive'), html: true, transform: this.showBoolean },
        { prop: 'isEmailConfirmed', label: L.localize('Label_IsEmailConfirmed'), html: true, transform: this.showBoolean }
      ]
      return headers
    }
  }
}
</script>



// WEBPACK FOOTER //
// Users.vue?e4ab16a4